import type { ReactNode } from 'react'

import badgeAnimated from '@/assets/logo/badge-animated.svg'

export const LoadingScreen = (): ReactNode => (
  <div className="flex min-h-screen items-center justify-center bg-background">
    <div className="flex flex-col items-center gap-4">
      <img src={badgeAnimated} alt="Loading" className="h-12 w-12 grayscale brightness-150" />
      <p className="text-sm text-muted-foreground">Loading...</p>
    </div>
  </div>
)
